import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrShuffleIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M6.90078 10.0004C7.20078 10.2004 7.30078 10.7004 7.00078 11.0004C6.20078 12.0004 5.00078 12.6004 3.70078 12.6004H1.00078C0.600781 12.6004 0.300781 12.3004 0.300781 11.9004C0.300781 11.5004 0.600781 11.2004 1.00078 11.2004H3.80078C4.60078 11.2004 5.50078 10.8004 6.00078 10.1004C6.20078 9.80039 6.60078 9.70039 6.90078 10.0004ZM8.70078 8.10039C9.00078 8.30039 9.50078 8.20039 9.70078 7.80039L10.3008 6.80039C11.0008 5.60039 12.1008 4.80039 13.4008 4.60039L12.6008 5.50039C12.3008 5.80039 12.3008 6.20039 12.6008 6.50039C12.9008 6.80039 13.3008 6.80039 13.6008 6.50039L15.6008 4.40039C15.7008 4.30039 15.8008 4.10039 15.8008 3.90039C15.8008 3.70039 15.7008 3.50039 15.6008 3.40039L13.6008 1.50039C13.3008 1.20039 12.9008 1.20039 12.6008 1.50039C12.3008 1.80039 12.3008 2.20039 12.6008 2.50039L13.4008 3.20039C11.5008 3.50039 9.90078 4.50039 9.00078 6.10039L8.40078 7.10039C8.20078 7.50039 8.30078 7.90039 8.70078 8.10039ZM13.5008 9.00039C13.2008 8.70039 12.8008 8.70039 12.5008 9.00039C12.2008 9.30039 12.2008 9.70039 12.5008 10.0004L13.3008 10.9004H12.2008C10.5008 10.9004 9.00078 9.90039 8.30078 8.40039L7.40078 6.50039C6.50078 4.50039 4.40078 3.20039 2.20078 3.20039H1.00078C0.600781 3.20039 0.300781 3.50039 0.300781 3.90039C0.300781 4.30039 0.600781 4.60039 1.00078 4.60039H2.30078C4.00078 4.60039 5.50078 5.60039 6.20078 7.10039L7.00078 8.90039C7.90078 10.9004 10.0008 12.2004 12.2008 12.2004H13.5008L12.5008 13.4004C12.2008 13.7004 12.3008 14.1004 12.6008 14.4004C12.9008 14.7004 13.3008 14.6004 13.6008 14.3004L15.6008 12.0004C15.8008 11.7004 15.8008 11.3004 15.6008 11.1004L13.5008 9.00039Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrShuffleIconComponent;
